export const NAV_ITEMS = [
  { key: 'ekyc', label: 'Xác thực (eKYC)', path: '/xchange/ekyc', icon: 'shield' },
  { key: 'connector', label: 'Kết nối', path: '/xchange/connector', icon: 'link' },
  { key: 'trading', label: 'Giao dịch', path: '/xchange/trading', icon: 'chart' },
  { key: 'orders', label: 'Sổ lệnh', path: '/xchange/orders', icon: 'clipboard' },
  { key: 'portfolio', label: 'Quản lý tài sản', path: '/xchange/portfolio', icon: 'wallet' },
];

export const EKYC_STEPS = {
  OCR: 'OCR',
  FACE_MATCH: 'FACE_MATCH',
  LIVENESS: 'LIVENESS',
  CONFIRM: 'CONFIRM',
};

export const EKYC_STATUS = {
  IDLE: 'IDLE',
  INITIATED: 'INITIATED',
  OCR_COMPLETED: 'OCR_COMPLETED',
  FACE_MATCH_COMPLETED: 'FACE_MATCH_COMPLETED',
  LIVENESS_COMPLETED: 'LIVENESS_COMPLETED',
  CONFIRMED: 'CONFIRMED',
  VERIFIED: 'VERIFIED',
  REJECTED: 'REJECTED',
  ERROR: 'ERROR',
};
